var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 35071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9412 19.5493L16.4612 21.0693L19.5012 18.0293",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6577 11.37C12.5577 11.36 12.4377 11.36 12.3277 11.37C9.94765 11.29 8.05765 9.34 8.05765 6.94C8.04765 4.49 10.0377 2.5 12.4877 2.5C14.9377 2.5 16.9277 4.49 16.9277 6.94C16.9277 9.34 15.0277 11.29 12.6577 11.37Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4886 22.3097C10.6686 22.3097 8.85857 21.8497 7.47857 20.9297C5.05857 19.3097 5.05857 16.6697 7.47857 15.0597C10.2286 13.2197 14.7386 13.2197 17.4886 15.0597",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUid);
export default __webpack_public_path__ + "static/media/uid.f1591da787302d6732368614151c17cb.svg";
export { ForwardRef as ReactComponent };